import * as React from 'react';
import {
    BodyMediumRegular,
    Button,
    ButtonSize,
    ButtonVariant,
    Sheet,
    YStack,
} from 'smoothie';

import { useSendEmailToSupport } from '../../../../common/hooks/useSendEmailToSupport';
import { useAuthedUser } from '../../../../common/providers/AuthedUserProvider';

interface AccountLimitSheetProps {
    isOpen: boolean;
    onClose: () => void;
}

const AccountLimitSheet = ({ isOpen, onClose }: AccountLimitSheetProps) => {
    const { depositoryAccountLimit } = useAuthedUser();
    const sendEmailToSupport = useSendEmailToSupport();

    return (
        <Sheet
            isOpen={isOpen}
            onClose={onClose}
            title="Account limit"
            showCloseButton
        >
            <YStack
                alignItems="center"
                justifyContent="space-between"
                width="100%"
                maxWidth={500}
                alignSelf="center"
            >
                <BodyMediumRegular
                    marginTop={8}
                    marginBottom={24}
                    maxWidth={420}
                >
                    You&apos;ve reached the limit of {depositoryAccountLimit}{' '}
                    total Fruitful bank accounts per member. Reach out to the
                    Hospitality team to learn more.
                </BodyMediumRegular>
                <Button
                    variant={ButtonVariant.SECONDARY}
                    size={ButtonSize.LARGE}
                    text="Contact Fruitful Hospitality"
                    onPress={() => {
                        void sendEmailToSupport();
                    }}
                />
            </YStack>
        </Sheet>
    );
};

export default AccountLimitSheet;
